var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-row');
import { breakpoints, theme } from '@shapeable/theme';
import { coalesce } from '../../utils/coalesce';
import { EntityValue } from './entity-value';
import { EntityLinkValue } from './entity-link-value';
import { ContentNode } from './content-node';
export var EntityRowDefaultProps = {
  showDescription: false,
  useLinks: false
}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    font-size: ", ";\n    align-items: stretch;\n    width: 100%;\n    box-sizing: border-box;\n\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    font-size: ", ";\n    align-items: stretch;\n    width: 100%;\n    box-sizing: border-box;\n\n    button.ellipsis-button {\n      visibility: hidden;\n    }\n\n    &:hover button.ellipsis-button {\n      visibility: visible;\n    }\n  "])), theme.FONT_SIZE(15))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  "])))
});
var ColumnStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "])))
});
var StartStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    padding-right: ", ";\n    flex-grow: 1;\n  "], ["\n    ", ";\n    padding-right: ", ";\n    flex-grow: 1;\n  "])), ColumnStyles, theme.UNIT(3))
});
var EndStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), ColumnStyles)
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-top: ", ";\n    color: ", ";\n    font-size: 1em;\n    line-height: 1.6em;\n  "], ["\n    padding-top: ", ";\n    color: ", ";\n    font-size: 1em;\n    line-height: 1.6em;\n  "])), theme.UNIT(3), theme.COLOR('text'))
});
var ValueStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Start: styled.div.attrs(cls.attr('start'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), StartStyles),
  Value: styled(EntityValue)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkValue: styled(EntityLinkValue)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  End: styled.div.attrs(cls.attr('end'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), EndStyles),
  Description: styled(ContentNode)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var EntityRow = function EntityRow(props) {
  var className = props.className,
      entity = props.entity,
      showDescription = props.showDescription,
      name = props.name,
      showLabel = props.showLabel,
      imageSize = props.imageSize,
      children = props.children,
      useLinks = props.useLinks,
      variant = props.variant,
      imageStyle = props.imageStyle,
      wrap = props.wrap,
      subtitle = props.subtitle,
      label = props.label,
      imageSpacing = props.imageSpacing,
      showMenu = props.showMenu;
  var description = coalesce(entity, ['description', 'openGraph.description', 'openGraph.description']);
  var hasDescription = showDescription && description && description.text;
  var Value = useLinks ? My.LinkValue : My.Value;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Body, null, React.createElement(My.Start, null, React.createElement(Value, {
    wrap: wrap,
    label: label,
    subtitle: subtitle,
    showMenu: showMenu,
    variant: variant,
    imageStyle: imageStyle,
    imageSize: imageSize,
    imageSpacing: imageSpacing,
    showLabel: showLabel,
    name: name,
    entity: entity
  })), React.createElement(My.End, null)), hasDescription && React.createElement(My.Description, {
    className: cls.sub('description'),
    entity: description
  }), children);
};
EntityRow.defaultProps = EntityRowDefaultProps;
EntityRow.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;